import { useIsPromoMini } from "@/hooks/useIsPromoMini";

import CasinoSkeleton from "./CasinoSkeleton";
import ConsecutiveDaysSkeleton from "@/widgets/casinoWidget/subWidgets/consecutiveDaysWidget/components/skeleton/ConsecutiveDaysSkeleton";
import styles from "./CasinoSkeletonLayout.module.scss";

type Props = {
  variant?: "default" | "consecutiveDay";
};

const CasinoSkeletonLayout = ({ variant = "default" }: Props) => {
  const isMini = useIsPromoMini();

  return (
    <div className={styles.layout}>
      <div className={styles.banner}>
        <CasinoSkeleton variant="banner" />
      </div>
      <div className={styles.header}>
        <CasinoSkeleton variant="title" />
        <CasinoSkeleton variant="subtitle" />
      </div>
      {variant === "consecutiveDay" ? (
        <ConsecutiveDaysSkeleton isMini={isMini} />
      ) : (
        <>
          <div className={styles.buttons}>
            <CasinoSkeleton variant="button" />
            <CasinoSkeleton variant="button" />
          </div>
          <CasinoSkeleton variant="default" />
        </>
      )}
    </div>
  );
};

export default CasinoSkeletonLayout;
